// extracted by mini-css-extract-plugin
export var calendarView = "_ox-0";
export var dayButton = "_ox-1";
export var dayCircle = "_ox-2";